// Ukrainian catalog. Typed as the English catalog, so a missing or extra key fails the build (SPEC §10.2).

import type { Catalog } from "./en";

export const uk: Catalog = {
  app: {
    productName: "WebUniverse",
    loading: "Завантаження…",
    readOnly: "Лише перегляд",
    save: "Зберегти",
    saving: "Збереження…",
    cancel: "Скасувати",
    close: "Закрити",
    delete: "Видалити",
    archive: "В архів",
    unarchive: "З архіву",
    archived: "В архіві",
    edit: "Редагувати",
    add: "Додати",
    remove: "Прибрати",
    create: "Створити",
    search: "Пошук",
    showArchived: "Показати архівні",
    none: "—",
    allDay: "Увесь день",
    noPeriods: "Недоступності немає.",
    saveAnyway: "Все одно зберегти",
    reload: "Оновити",
    previous: "Назад",
    next: "Далі",
    today: "Сьогодні",
    tomorrow: "Завтра",
    thisWeek: "Цей тиждень",
    date: "Дата",
    from: "З",
    to: "По",
    time: "Час",
    start: "Початок",
    end: "Кінець",
    length: "Тривалість",
    note: "Примітка",
    reason: "Причина",
    name: "Назва",
    actions: "Дії",
    yes: "Так",
    no: "Ні",
    saved: "Збережено",
    deleted: "Видалено",
    notFound: "Такої сторінки немає.",
    forbidden: "У вас немає доступу до цієї сторінки.",
    goHome: "На головну",
    unknownError: "Невідома помилка ({code})",
    networkError: "Сервер недоступний. Перевірте з’єднання і спробуйте ще раз.",
    concurrentEdit: "Хтось інший уже змінив це. Оновіть, щоб побачити останню версію.",
    sessionExpired: "Сеанс завершився. Увійдіть знову.",
  },
  nav: {
    dayView: "День",
    groups: "Групи",
    teachers: "Викладачі",
    changes: "Зміни",
    admin: "Адміністрування",
    centers: "Центри й кабінети",
    courses: "Курси",
    users: "Користувачі",
    travelTimes: "Час на дорогу",
    mySchedule: "Мій розклад",
    notifications: "Сповіщення",
    changePassword: "Змінити пароль",
    signOut: "Вийти",
    language: "Мова",
    theme: "Тема",
    menu: "Меню",
  },
  theme: {
    light: "Світла",
    dark: "Темна",
    system: "Як у системі",
  },
  signIn: {
    title: "Вхід",
    username: "Ім’я користувача",
    password: "Пароль",
    submit: "Увійти",
  },
  password: {
    title: "Зміна пароля",
    current: "Поточний пароль",
    new: "Новий пароль",
    repeat: "Повторіть новий пароль",
    mismatch: "Нові паролі не збігаються.",
    changed: "Пароль змінено.",
  },
  day: {
    title: "День",
    center: "Центр",
    noCenters: "Центрів ще немає. Додайте в Адміністрування → Центри й кабінети.",
    noClassrooms: "У цьому центрі немає кабінетів.",
    closed: "Центр зачинено ({reason})",
    overlapWarning: "Уроки накладаються",
    allCenters: "Усі центри",
    view: "Вигляд",
    viewGrid: "Сітка",
    viewList: "Список",
    attentionTitle: "Потребує уваги",
    nothingNeedsAttention: "Нічого не потребує уваги.",
    noLessons: "Уроків немає.",
    insteadOf: "замість {name}",
  },
  lessonFlags: {
    substituted: "Заміна",
    cancelled: "Скасовано",
    moved: "Перенесено",
    roomChanged: "Інший кабінет",
    problem: "Проблема",
    centerClosed: "Центр зачинено",
    unavailable: "Недоступно",
  },
  groups: {
    title: "Групи",
    newGroup: "Нова група",
    name: "Назва",
    course: "Курс",
    mainTeacher: "Основний викладач",
    room: "Кабінет",
    slots: "Заняття на тиждень",
    startDate: "Дата початку",
    endDate: "Дата завершення",
    currentPlan: "Поточний план",
    periods: "Історія плану",
    validFrom: "Діє з",
    lessons: "Уроки",
    findReplacement: "Знайти заміну",
    changePlan: "Змінити план",
    applyFrom: "Застосувати з",
    editIdentity: "Змінити назву, примітку, дату завершення",
    addSlot: "Додати заняття",
    removeSlot: "Прибрати",
    day: "День",
    notQualified: "не веде цей курс",
    created: "Групу створено.",
    planSaved: "План збережено. Уроки перевірено з {from} по {to}.",
    orphansTitle: "Ці зміни уроків залишаться без уроку:",
    deleteOrphans: "Видалити їх і зберегти",
    noGroups: "Груп немає.",
    archivedOn: "В архіві з {date}",
  },
  lesson: {
    title: "Урок",
    group: "Група",
    course: "Курс",
    teacher: "Викладач",
    mainTeacher: "Основний викладач",
    room: "Кабінет",
    center: "Центр",
    movedFrom: "перенесено з {time}",
    note: "Примітка (лише для адміністраторів)",
    teacherNote: "Примітка для викладача",
    cancel: "Скасувати урок",
    restore: "Відновити урок",
    changeRoom: "Змінити кабінет",
    resetRoom: "Повернути кабінет",
    moveTime: "Перенести час",
    resetTime: "Повернути час",
    editNote: "Змінити примітку",
    editTeacherNote: "Змінити примітку для викладача",
    backToMainTeacher: "Повернути основного викладача",
    candidates: "Кандидати",
    rank: "№",
    score: "Бали",
    reasons: "Чому",
    contacts: "Контакти",
    assign: "Призначити",
    showExcluded: "Показати відсіяних ({count})",
    hideExcluded: "Сховати відсіяних",
    nobody: "Немає вільних викладачів цього курсу.",
    history: "Історія",
    noHistory: "Змін ще не було.",
    conflictsTitle: "Ця зміна конфліктує з розкладом:",
    closedNoCandidates: "Центр того дня зачинено, тому кандидатів немає. Можна перенести урок в інший кабінет.",
    dataProblems: "Проблеми з даними",
  },
  teachers: {
    title: "Викладачі",
    newTeacher: "Новий викладач",
    firstName: "Ім’я",
    lastName: "Прізвище",
    phone: "Телефон",
    email: "Ел. пошта",
    telegram: "Telegram",
    courses: "Курси",
    ownGroups: "Групи",
    contacts: "Контакти",
    week: "Тиждень",
    weeklyUnavailable: "Щотижнева недоступність",
    addWeekly: "Додати щотижневий час",
    unavailability: "Недоступність",
    addPeriod: "Додати недоступність",
    affectedTitle: "Уроки, яких це стосується:",
    noAffected: "Жодного уроку це не стосується.",
    conflictBanner: "Уроки цього тижня в недоступний час:",
    createLogin: "Створити вхід",
    loginStatus: "Вхід: {username}, {status}",
    active: "активний",
    inactive: "неактивний",
    noTeachers: "Викладачів немає.",
  },
  changes: {
    title: "Зміни",
    entityType: "Тип запису",
    allTypes: "Усі",
    when: "Коли",
    who: "Хто",
    what: "Що",
    record: "Запис",
    details: "Подробиці",
    page: "Сторінка {page} з {pages}",
    empty: "За цей період змін немає.",
  },
  admin: {
    centers: "Центри",
    addCenter: "Додати центр",
    address: "Адреса",
    closures: "Дні, коли центр зачинено",
    noClosures: "Закриттів немає.",
    addClosure: "Додати",
    alsoAllCenters: "Додати також до всіх інших центрів",
    lessonsNotTakingPlace: "Ці уроки не відбудуться:",
    travelTimes: "Час на дорогу",
    travelHelp: "Хвилини між центрами. Порожнє поле — значення за замовчуванням ({minutes} хв).",
    classrooms: "Кабінети",
    addClassroom: "Додати кабінет",
    capacity: "Місткість",
    courses: "Курси",
    addCourse: "Додати курс",
    teacherCount: "Викладачі",
    groupCount: "Групи",
    users: "Користувачі",
    addUser: "Додати користувача",
    username: "Ім’я користувача",
    displayName: "Ім’я для показу",
    role: "Роль",
    linkedTeacher: "Викладач",
    lastLogin: "Останній вхід",
    status: "Стан",
    initialPassword: "Початковий пароль",
    deactivate: "Вимкнути",
    activate: "Увімкнути",
    resetPassword: "Скинути пароль",
    newPassword: "Новий пароль",
    passwordReset: "Пароль скинуто.",
    allRoles: "Усі ролі",
    deleteConfirm: "Видалити назавжди? Натисніть ще раз для підтвердження.",
  },
  mySchedule: {
    title: "Мій розклад",
    list: "Список",
    grid: "Тиждень",
    upcoming: "Найближчі 14 днів",
    nothing: "Уроків у найближчі 14 днів немає.",
    substitutingFor: "Заміна замість {name}",
    coveredBy: "Замінює {name}",
    noteForYou: "Примітка: {note}",
  },
  notifications: {
    title: "Сповіщення",
    seeAll: "Усі сповіщення",
    markAllRead: "Позначити все прочитаним",
    empty: "Сповіщень немає.",
    unreadOnly: "Лише непрочитані",
  },
  errors: {
    UNAUTHORIZED: "Будь ласка, увійдіть.",
    FORBIDDEN: "У вас немає доступу до цього.",
    INVALID_CREDENTIALS: "Неправильне ім’я користувача або пароль",
    TOO_MANY_ATTEMPTS: "Забагато невдалих спроб. Зачекайте 5 хвилин.",
    FORBIDDEN_SELF_DEACTIVATE: "Не можна вимкнути власний обліковий запис.",
    LAST_ADMIN: "Має залишатися хоча б один активний адміністратор.",
    NOT_FOUND: "Не знайдено.",
    VALIDATION_FAILED: "Виправте позначені поля.",
    CONCURRENT_EDIT: "Хтось інший уже змінив це. Оновіть, щоб побачити останню версію.",
    IN_USE: "Ще використовується ({references}). Перенесіть в архів.",
    SCHEDULE_CONFLICTS: "Зміна конфліктує з розкладом.",
    ORPHANED_LESSON_CHANGES: "Деякі зміни уроків залишаться без уроку.",
    PERIOD_BEFORE_LATEST: "План можна змінити лише з дати останнього плану або пізніше.",
    PERIOD_IN_PAST: "План можна змінити лише з сьогодні або пізніше; минулі уроки зберігають свій план.",
    LESSON_NOT_ON_DATE: "У групи немає такого уроку цього дня.",
    LESSON_CANCELLED: "Урок скасовано.",
    INTERNAL_ERROR: "На сервері сталася помилка.",
  },
  fieldErrors: {
    REQUIRED: "Обов’язкове поле",
    TOO_LONG: "Не більше {max} символів",
    TOO_SHORT: "Щонайменше {min} символів",
    UNKNOWN_REFERENCE: "Не знайдено",
    ARCHIVED_REFERENCE: "В архіві — виберіть інше",
    RANGE_INVALID: "Неправильний час",
    DATE_RANGE_INVALID: "Кінець раніше за початок",
    DATE_IN_PAST: "Не раніше ніж учора: минулі уроки зникли б",
    DATE_RANGE_TOO_LONG: "Не більше {maxDays} днів",
    SLOTS_OVERLAP: "Накладається на інше заняття",
    DUPLICATE_NAME: "Така назва вже є",
    PASSWORD_TOO_SHORT: "Щонайменше {min} символів",
    WRONG_PASSWORD: "Неправильний пароль",
    TEACHER_REQUIRED_FOR_ROLE: "Виберіть викладача",
    TEACHER_NOT_ALLOWED_FOR_ROLE: "Викладача можна прив’язати лише до входу викладача",
    TEACHER_HAS_ACCOUNT: "У цього викладача вже є вхід",
    DUPLICATE_USERNAME: "Це ім’я користувача вже зайняте",
    REASON_NOT_ALLOWED: "Цю причину тут не можна вибрати",
    USERNAME_INVALID: "3–50 літер, цифр, '.', '_' або '-'",
    DUPLICATE_PAIR: "Ця пара центрів указана двічі",
  },
  conflicts: {
    TEACHER_DOUBLE_BOOKED: "Викладач у цей час веде {otherLesson}",
    ROOM_DOUBLE_BOOKED: "Кабінет у цей час зайнятий: {otherLesson}",
    TEACHER_NOT_QUALIFIED: "Викладач не веде цей курс",
    TEACHER_UNAVAILABLE: "Викладач недоступний ({reason}, {range})",
    ROOM_UNAVAILABLE: "Кабінет недоступний ({reason}, {range})",
    CENTER_CLOSED: "Центр того дня зачинено ({reason})",
  },
  exclusions: {
    CURRENT_TEACHER: "Веде цей урок",
    ARCHIVED: "В архіві",
    NOT_QUALIFIED: "Не веде цей курс",
    UNAVAILABLE: "Недоступний ({reason}, {range})",
    BUSY: "Зайнятий: {lesson}",
    CANT_TRAVEL: "Не встигне доїхати: {lesson}, проміжок {gapMinutes} хв, треба {travelMinutes} хв",
  },
  reasons: {
    BASE: "Базові",
    SAME_CENTER_ADJACENT: "Вже в цьому центрі ({lesson})",
    TRAVEL: "Дорога: проміжок {gapMinutes} хв, треба {travelMinutes} хв ({lesson})",
    KNOWS_GROUP: "Знає групу (останній раз {lastDate})",
    RECENT_SUBSTITUTIONS: "Нещодавніх замін: {count}",
    DAY_LOAD: "Уроків того дня: {count}",
  },
  dataProblems: {
    MISSING_TEACHER: "Немає викладача",
    MISSING_CLASSROOM: "Немає кабінету",
    MISSING_CENTER: "Немає центру",
    MISSING_COURSE: "Немає курсу",
  },
  gridProblems: {
    LessonDuringUnavailableTime: "{lesson} — у недоступний час",
    LessonsOverlap: "{lesson} накладається на {otherLesson}",
  },
  actions: {
    LESSON_CANCELLED: "Скасував(ла) урок",
    LESSON_RESTORED: "Відновив(ла) урок",
    SUBSTITUTE_ASSIGNED: "Призначив(ла) заміну",
    SUBSTITUTE_REMOVED: "Повернув(ла) основного викладача",
    ROOM_CHANGED: "Змінив(ла) кабінет",
    ROOM_RESET: "Повернув(ла) кабінет",
    TIME_CHANGED: "Переніс(ла) урок",
    TIME_RESET: "Повернув(ла) запланований час",
    NOTE_CHANGED: "Змінив(ла) примітку",
    TEACHER_NOTE_CHANGED: "Змінив(ла) примітку для викладача",
    UNAVAILABILITY_ADDED: "Додав(ла) недоступність",
    UNAVAILABILITY_REMOVED: "Прибрав(ла) недоступність",
    GROUP_CREATED: "Створив(ла) групу",
    GROUP_PLAN_CHANGED: "Змінив(ла) план групи",
    GROUP_UPDATED: "Змінив(ла) групу",
    LESSON_CHANGES_ORPHAN_DELETED: "Видалив(ла) зміну уроку, що лишилася без уроку",
    RECORD_CREATED: "Створив(ла)",
    RECORD_UPDATED: "Змінив(ла)",
    RECORD_ARCHIVED: "Переніс(ла) в архів",
    RECORD_UNARCHIVED: "Повернув(ла) з архіву",
    RECORD_DELETED: "Видалив(ла)",
    USER_CREATED: "Створив(ла) обліковий запис",
    USER_DEACTIVATED: "Вимкнув(ла) обліковий запис",
    USER_ACTIVATED: "Увімкнув(ла) обліковий запис",
    PASSWORD_CHANGED: "Змінив(ла) свій пароль",
    PASSWORD_RESET: "Скинув(ла) пароль",
    CENTER_CLOSURE_ADDED: "Додав(ла) дні закриття центру",
    CENTER_CLOSURE_REMOVED: "Прибрав(ла) дні закриття центру",
    TRAVEL_TIMES_CHANGED: "Змінив(ла) час на дорогу",
  },
  notificationTypes: {
    YOU_SUBSTITUTE: "Ви замінюєте в {groupName} {date}, {range}",
    YOU_NO_LONGER_SUBSTITUTE: "Ви більше не замінюєте в {groupName} {date}",
    YOUR_LESSON_COVERED: "{substituteName} замінює ваш урок {groupName} {date}",
    YOUR_LESSON_COVER_REMOVED: "Ви знову ведете свій урок {groupName} {date}",
    LESSON_CANCELLED: "Урок {groupName} {date} скасовано",
    LESSON_RESTORED: "Урок {groupName} {date} знову відбудеться",
    LESSON_MOVED: "Урок {groupName} {date} перенесено на {range}",
    LESSON_ROOM_CHANGED: "Урок {groupName} {date} — у кабінеті {classroomName}",
    TEACHER_NOTE_CHANGED: "Нова примітка до уроку {groupName} {date}",
    CENTER_CLOSED: "{centerName} зачинено {dateFrom}–{dateTo}: ваших уроків не відбудеться — {count}",
    UNCOVERED_LESSONS: "У {teacherName} уроків без заміни: {count}, перший {firstDate}",
  },
  roles: {
    Admin: "Адміністратор",
    Viewer: "Спостерігач",
    Teacher: "Викладач",
  },
  unavailabilityReasons: {
    Sick: "Хвороба",
    Vacation: "Відпустка",
    Holiday: "Свято",
    RoomClosed: "Кабінет зачинено",
    Other: "Інше",
    Weekly: "Щотижня",
  },
  closureReasons: {
    Holiday: "Канікули/свято",
    Other: "Інше",
  },
  entityTypes: {
    Lesson: "Урок",
    Group: "Група",
    Teacher: "Викладач",
    Classroom: "Кабінет",
    Center: "Центр",
    Course: "Курс",
    User: "Користувач",
    TravelTimes: "Час на дорогу",
  },
  weekdays: {
    Monday: "Понеділок",
    Tuesday: "Вівторок",
    Wednesday: "Середа",
    Thursday: "Четвер",
    Friday: "П’ятниця",
    Saturday: "Субота",
    Sunday: "Неділя",
  },
  plurals: {
    lessons: { one: "{count} урок", few: "{count} уроки", many: "{count} уроків", other: "{count} уроку" },
    hours: { one: "{count} год", few: "{count} год", many: "{count} год", other: "{count} год" },
    minutes: { one: "{count} хв", few: "{count} хв", many: "{count} хв", other: "{count} хв" },
    excluded: {
      one: "{count} відсіяний",
      few: "{count} відсіяні",
      many: "{count} відсіяних",
      other: "{count} відсіяного",
    },
  },
};
